import React from 'react'

import type { UpsellsContentBlock as ApiUpsellsContentBlock } from '@library/api-menu-experience'

import { Products } from '../Products'
import { BasketUpsellSection } from './BasketUpsellSection'
import type { BasketUpsellProduct, BasketUpsellProductActionSource } from './types'
import { buildUpsellsContentBlockViewModel } from './upsellsContentBlockViewModel'

type UpsellsContentBlockProps = {
  basketGifts?: Record<string, number>
  basketProductQuantities: Record<string, number>
  block: ApiUpsellsContentBlock
  onAddProduct: (productId: string, source: BasketUpsellProductActionSource) => void
  onClickProduct: (product: BasketUpsellProduct) => void
  onRemoveProduct: (productId: string, source: BasketUpsellProductActionSource) => void
  pendingProductIds?: ReadonlySet<string>
}

export const UpsellsContentBlock = ({
  basketGifts,
  basketProductQuantities,
  block,
  onAddProduct,
  onClickProduct,
  onRemoveProduct,
  pendingProductIds,
}: UpsellsContentBlockProps) => {
  const { carousel, carouselProducts, selectedProducts } = buildUpsellsContentBlockViewModel({
    basketGifts,
    basketProductQuantities,
    block,
    pendingProductIds,
  })

  return (
    <>
      {carousel && (
        <BasketUpsellSection
          carousel={carousel}
          products={carouselProducts}
          onAddProduct={onAddProduct}
          onClickProduct={onClickProduct}
          onRemoveProduct={onRemoveProduct}
        />
      )}
      <Products
        products={selectedProducts}
        onAddProduct={onAddProduct}
        onClickProduct={onClickProduct}
        onRemoveProduct={onRemoveProduct}
      />
    </>
  )
}
